module.exports = __webpack_public_path__ + "img/architecture-style-icon_5.6734e007.png";